import { EntertainmentVideoItemBlank } from 'modules/entertainment-videos/types';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import React, { useState } from 'react';
import { __t, applyTranslations } from 'utils/language';
import './entertainment-video-items.scss';
import RealmOutfitItemForm from 'modules/realm-outfits/components/realm-outfit-item-form/RealmOutfitItemForm';
import { RealmOutfitItemResource } from 'types';
import AddNew from 'components/buttons/add-new/AddNew';

applyTranslations(require('./entertainment-video-items.i18n.json'));

function translate(path: string) {
  return __t(`entertainmentVideoItemList${path}`);
}

export function EntertainmentVideoItems({
  items,
  isEditMode = false,
  onAddItem,
  onDeleteItem
}: {
  items: Array<EntertainmentVideoItemBlank>,
  isEditMode?: boolean,
  onAddItem?: (item: RealmOutfitItemResource) => void,
  onDeleteItem?: (item: EntertainmentVideoItemBlank) => void
}) {
  const [isAddingNewItem, setIsAddingNewItem] = useState(false);

  return (
    <div>
      {items.length > 0 ? (
        <ul className="ev-item-list">
          {items.map((item) => (
            <li key={item.sku}>
              <div className="ev-list-item">
                <div className="ev-list-item__image-container">
                  <img className="ev-list-item__image" alt={item.sku} src={item.imageUrl} />
                </div>
                <a
                  href={item.itemUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ev-list-item__label"
                >
                  {translate(item.isSimilar ? '.similar' : '.exact')}
                </a>
                {isEditMode && (
                  <div className="ev-list-item__overlay">
                    <button
                      type="button"
                      className="ev-list-item__delete-btn"
                      onClick={() => {
                        onDeleteItem?.(item);
                      }}
                    >
                      <SVGDynamicIcon
                        name="trash-custom-fg"
                        width={20}
                        height={20}
                      />
                    </button>
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <span>–</span>
      )}
      {isEditMode && (
        <div className="ev-item-list__form-container">
          {isAddingNewItem ? (
            <RealmOutfitItemForm
              onSubmit={(item) => {
                onAddItem?.(item);
              }}
            />
          ) : (
            <AddNew
              text={translate('.add')}
              icon={{
                name: 'plus-inside-circle-custom-bg-white-fg',
                width: 24,
                height: 24
              }}
              onClick={() => setIsAddingNewItem(true)}
            />
          )}
        </div>
      )}
    </div>
  );
}
